import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { collection, query, where, getDocs, doc, updateDoc, orderBy } from 'firebase/firestore';
import { db } from '../../firebase/config';
import { useUser } from '../../contexts/UserContext';
import { format } from 'date-fns';
import { 
  Box, 
  Typography, 
  Button, 
  Chip, 
  CircularProgress,
  List,
  ListItem,
  ListItemText,
  ListItemSecondaryAction,
  IconButton,
  Divider,
  Alert,
  Paper,
  Card,
  CardContent,
  Grid
} from '@mui/material';
import { 
  CheckCircle as CheckCircleIcon, 
  Cancel as CancelIcon,
  Delete as DeleteIcon,
  Send as SendIcon,
  Event as EventIcon
} from '@mui/icons-material';

// Interface for EventInvitation
interface EventInvitation {
  id: string;
  eventId: string;
  eventTitle: string;
  email: string;
  status: 'pending' | 'accepted' | 'declined';
  createdAt: Date;
  expiresAt?: Date;
  eventType?: string;
}

const EventInvitationStatus: React.FC<{
   declinedCount: number;
   acceptedCount: number;
   pendingCount: number;
}> = ({ declinedCount, acceptedCount, pendingCount }) => {
   const navigate = useNavigate();

   // Create event
   const handleCreateEvent = () => {
      navigate('/events/create');
   };

   return (
      <Box>
         {/* Invitation Stats */}
         <Grid container spacing={2} sx={{ mb: 2 }}>
            <Grid item xs={4}>
               <Paper
                  variant='outlined'
                  sx={{
                     p: 1,
                     textAlign: 'center',
                     bgcolor: 'warning.light',
                     color: 'warning.contrastText',
                     borderRadius: 2,
                  }}
               >
                  <Typography variant='h5'>{pendingCount}</Typography>
                  <Typography variant='body2'>Pending</Typography>
               </Paper>
            </Grid>
            <Grid item xs={4}>
               <Paper
                  variant='outlined'
                  sx={{
                     p: 1,
                     textAlign: 'center',
                     bgcolor: 'success.light',
                     color: 'success.contrastText',
                     borderRadius: 2,
                  }}
               >
                  <Typography variant='h5'>{acceptedCount}</Typography>
                  <Typography variant='body2'>Accepted</Typography>
               </Paper>
            </Grid>
            <Grid item xs={4}>
               <Paper
                  variant='outlined'
                  sx={{
                     p: 1,
                     textAlign: 'center',
                     bgcolor: 'error.light',
                     color: 'error.contrastText',
                     borderRadius: 2,
                  }}
               >
                  <Typography variant='h5'>{declinedCount}</Typography>
                  <Typography variant='body2'>Declined</Typography>
               </Paper>
            </Grid>
         </Grid>

         {/* No invitations state */}
         {pendingCount == 0 && acceptedCount == 0 && declinedCount == 0 && (
            <Box sx={{ py: 2, textAlign: 'center' }}>
               <Typography variant='body1' color='text.secondary' paragraph>
                  No event invitations yet.
               </Typography>
               <Button variant='outlined' startIcon={<EventIcon />} onClick={handleCreateEvent}>
                  Create Event
               </Button>
            </Box>
         )}
      </Box>
   );
};

export default EventInvitationStatus; 